//
//
//
//
//
import React, {useState, useEffect} from 'react';
import ReactWordcloud from 'react-wordcloud';

const Wordcloud = ({words}) => {
    // const [wordArr, setWordArr] = useState([]);

    const testwords = [
        {
            text: 'told',
            value: 64,
        },
        {
            text: 'mistake',
            value: 11,
        },
        {
            text: 'thought',
            value: 16,
        },
        {
            text: 'bad',
            value: 17,
        },
    ]

    const colorValues = ['#123b98', '#4b70b6', '#5f81c4', '#85a1dc','#adc4f4'];

    // useEffect(() => {
    //     let newArr = [];
    //     words && words.length > 0 && words.forEach(item => {
    //         // newArr.push({text: item.keyword, value: item.score * 1000})
    //         newArr.push({text: item.keyword, value: (1 / item.score)})
    //     })
    //     console.log(newArr)
    //     setWordArr(newArr);
    // }, []);

    const callbacks = {
        // getWordColor: word => word.value > 50 ? "blue" : "red",
        // getWordColor: word => '#141c6f',
        // onWordClick: console.log,
        // onWordMouseOver: console.log,
        // getWordTooltip: word => `${word.text} (${word.value})`,
    }
    const options = {
        rotations: 0,
        rotationAngles: [0],
        colors: colorValues,
        fontSizes: [14, 32],
        fontWeight: '600',
        scale: 'sqrt',
        spiral: 'rectangular',
        // padding: 1,
        // colors: ['#141c6f'],
        // spiral: "rectangular",
        transitionDuration: 0,
        fontFamily: 'sans-serif',
        deterministic: true,
        enableTooltip: false,
        // disableRandomColor: true,
    };
    // const size = [300, 50];
    // const minSize = [300, 200];


    // console.log(words)
    if(words && words.length === 0) {
        return (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                <div style={{fontWeight: '500'}}>Not yet enough articles to detect keywords</div>
            </div>
        )
    }
    return (
        <ReactWordcloud
            words={words}
            // callbacks={callbacks}
            options={options}
            // size={size}
            // minSize={minSize}

        />
    )
};

export default Wordcloud;

// import React from 'react';
// import ReactWordcloud from 'react-wordcloud';
//
// const words = [
//     {
//         text: 'told',
//         value: 64,
//     },
//     {
//         text: 'mistake',
//         value: 11,
//     },
//     {
//         text: 'thought',
//         value: 16,
//     },
//     {
//         text: 'bad',
//         value: 17,
//     },
// ]
//
// function SimpleWordcloud() {
//     return <ReactWordcloud words={words} />
// }
//
// export default SimpleWordcloud;